export function Overline({ children, className = "" }) {
  return (
    <span className={`font-head text-xs md:text-sm font-bold uppercase tracking-[0.4em] text-primary ${className}`}>
      {children}
    </span>
  );
}

export function SectionHeading({ overline, title, subtitle, center = false, dark = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl`}>
      {overline && <Overline>{overline}</Overline>}
      <h2 className={`font-head text-3xl md:text-5xl font-medium uppercase tracking-[0.15em] mt-4 ${dark ? "text-white" : "text-[#0A0A0A]"}`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-foreground/70"}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
